module.exports = __webpack_public_path__ + "img/percayso-pattern.aa89c54c.png";